import React from 'react'
import {Button, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useRealtimeStore} from '../../store/realtimeStore'
import {usePolicyChatDrawerStore} from '../../store/policyChatDrawerStore'

const containerStyle: React.CSSProperties = {
  position: 'fixed',
  top: 'calc(50% + 70px)',
  right: 0,
  transform: 'translateY(-50%)',
  zIndex: 1051,
}

const buttonStyle: React.CSSProperties = {
  borderRadius: '10px 0 0 10px',
  padding: '8px 12px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
  position: 'relative',
}

const badgeStyle: React.CSSProperties = {
  position: 'absolute',
  top: -6,
  right: -6,
  background: '#dc3545',
  color: '#fff',
  borderRadius: '999px',
  fontSize: '0.65rem',
  fontWeight: 700,
  minWidth: 18,
  height: 18,
  padding: '0 5px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1,
}

export const PolicyChatFloatingButton: React.FC = () => {
  const open = usePolicyChatDrawerStore((state) => state.open)
  const toggle = usePolicyChatDrawerStore((state) => state.toggle)
  const unreadCount = useRealtimeStore((state) => state.sidebarCounters.policyChatUnreadCount)

  const tooltipLabel = open ? 'Hide PolicyChat' : 'Open PolicyChat'

  return (
    <div style={containerStyle} id='global-policychat-floating-button'>
      <OverlayTrigger
        placement='left'
        overlay={<Tooltip id='policychat-floating-tooltip'>{tooltipLabel}</Tooltip>}
      >
        <Button
          style={buttonStyle}
          variant={open ? 'dark' : 'primary'}
          title={tooltipLabel}
          onClick={toggle}
        >
          <i className='bi bi-chat-heart-fill fs-4' />
          {unreadCount > 0 && !open && (
            <span style={badgeStyle}>{unreadCount > 99 ? '99+' : unreadCount}</span>
          )}
        </Button>
      </OverlayTrigger>
    </div>
  )
}
